import { ITimeFilter } from "../../../Typings/SearchFilters";
import { SelectChangeEvent } from "@mui/material";

export const TIME_FILTERS = {
  "day-button": { name: "Last Day", value: 1 },
  "week-button": { name: "Last Week", value: 7 },
  "month-button": { name: "Last Month", value: 30 },
  "year-button": { name: "Last Year", value: 365 },
  "all-time-button": { name: "All Time", value: null },
} as Record<string, ITimeFilter>;

export const TIME_FILTER_OPTIONS = Object.entries(TIME_FILTERS).map(([key, value]) => ({
  id: key,
  ...value,
})) as ITimeFilter[];

export function useTimeFilter(
  timeFilter: ITimeFilter,
  setTimeFilter: (time: ITimeFilter) => void,
  queryStartDate?: Date,
  queryEndDate?: Date,
) {
  const customDateString = `Custom: ${queryStartDate?.toLocaleDateString()} - ${queryEndDate?.toLocaleDateString()}`;

  const timeOptions = () => {
    const options = [...TIME_FILTER_OPTIONS];
    if (queryStartDate && queryEndDate) {
      options.push({
        id: "custom",
        name: customDateString,
        value: 999,
      });
    }

    return options;
  };

  const handleTimeChange = (event: SelectChangeEvent) => {
    const timeName = event.target.value;
    if (timeName) {
      const selectedOption = timeOptions().find((option) => option.name === timeName);
      if (selectedOption) {
        setTimeFilter(selectedOption);
      }
    }
  };

  const findOptionByValue = (value: number) => timeOptions().find((c) => c.value === value);

  const availableTimeOptions = timeOptions().map((option) => option.name);

  return {
    timeLabel: timeFilter.name,
    timeOptions,
    handleTimeChange,
    availableTimeOptions,
    findOptionByValue,
  };
}
